__turbopack_context__.v({
  "arrow": "styles-module-scss-module__ViEBHq__arrow",
  "arrowBtn": "styles-module-scss-module__ViEBHq__arrowBtn",
  "arrowIcon": "styles-module-scss-module__ViEBHq__arrowIcon",
  "arrowIcon_open": "styles-module-scss-module__ViEBHq__arrowIcon_open",
  "container": "styles-module-scss-module__ViEBHq__container",
  "grid": "styles-module-scss-module__ViEBHq__grid",
  "images": "styles-module-scss-module__ViEBHq__images",
  "open": "styles-module-scss-module__ViEBHq__open",
  "root": "styles-module-scss-module__ViEBHq__root",
  "rozclad": "styles-module-scss-module__ViEBHq__rozclad",
  "schedule": "styles-module-scss-module__ViEBHq__schedule",
  "schedule_open": "styles-module-scss-module__ViEBHq__schedule_open",
  "title": "styles-module-scss-module__ViEBHq__title",
  "title_first": "styles-module-scss-module__ViEBHq__title_first",
  "title_second": "styles-module-scss-module__ViEBHq__title_second",
});
